// src/components/auth/ForgotPasswordPage.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom"; // If using React Router for navigation
import authService from "../../api/authClient"; // Your API client
import "../../css/LoginPage.css"; // Can reuse login page styles
import skillMatchLogo from "../../assets/images/login/skillMatchLogo.svg"; // Your logo

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState(""); // For success or error messages
  const [isError, setIsError] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      setMessage("Please enter your email address.");
      setIsError(true);
      return;
    }

    setIsLoading(true);
    setMessage("");
    setIsError(false);

    try {
      // Call the backend API to request a password reset
      await authService.requestPasswordReset(email);
      setMessage(
        "If an account with that email exists, a password reset link has been sent. Please check your inbox (and spam folder)."
      );
      setIsError(false);
      setEmail(""); // Clear the email field on success
    } catch (error) {
      console.error("Forgot password error:", error);
      setMessage(
        error.response?.data?.detail ||
          "Failed to send password reset email. Please try again."
      );
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      {" "}
      {/* Reusing login-container for layout */}
      <div className="login-form-section" style={{ justifyContent: "center" }}>
        {" "}
        {/* Centering content */}
        <div className="logo-container">
          <img
            src={skillMatchLogo}
            alt="SkillMatchAI Logo"
            className="logo-image"
          />
        </div>
        <div className="form-container">
          <h1 className="form-title">Forgot Your Password?</h1>
          <p className="form-subtitle" style={{ marginBottom: "20px" }}>
            No problem! Enter your email address below and we'll send you a link
            to reset it.
          </p>

          {message && (
            <div className={isError ? "error-message" : "success-message"}>
              {message}
            </div>
          )}

          <form className="login-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label" htmlFor="email">
                Email Address
              </label>
              <input
                type="email"
                id="email"
                placeholder="you@example.com"
                className="form-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                disabled={isLoading}
              />
            </div>

            <button
              type="submit"
              className="signin-button" // Reusing signin-button style
              disabled={isLoading}
              style={{ marginTop: "20px" }}
            >
              {isLoading ? "Sending Link..." : "Send Reset Link"}
            </button>
          </form>

          <div className="signup-prompt" style={{ marginTop: "30px" }}>
            <Link to="/login" className="signup-link">
              Back to Login
            </Link>
          </div>
        </div>
      </div>
      {/* You might not need the marketing illustration section here, or a different one */}
      {/* <div className="marketing-section"> ... </div> */}
    </div>
  );
};

export default ForgotPasswordPage;
